import React, { Fragment, useEffect, useState } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import DatePicker from '../DatePicker'
import moment from 'moment/moment'
import Select, { components } from 'react-select'
import { reactSelectValue, truncateToTwoDecimals } from '../../utils/Helper'
import api from '../../utils/Api'
import _, { find, includes, isUndefined, toNumber } from 'lodash'
import useDialog from '../../hook/useDialog'
import ModalPaymentMethodForm from '../modal/ModalPaymentMethodForm'
import {
  BANK_LIST_ONLY_OPTIONS,
  BANK_LIST_OPTIONS,
  DEDUCT_DOCUMENT_INCOME_TYPE_OPTIONS,
  DEDUCT_DOCUMENT_TYPE_OPTIONS,
  IncomeDocumentStateTypes,
  IncomeDocumentTypes,
  PAYMENT_ADJUSTMENT_ACCOUNT_OPTIONS,
  PAYMENT_ADJUSTMENT_OPTIONS,
  PAYMENT_METHOD_OPTION,
  TAX_OPTIONS,
} from '../../constants/Common'
import { numberFormat } from '../../utils/Functions'
import usePayment from '../../hook/usePayment'
import { useLocation, useParams } from 'react-router-dom'
import useCommon from '../../hook/useCommon'
import { getPaymentGateways, PaymentGateway } from '../../modules/apps/finance/core/_requests'
import useAccounting from '../../hook/useAccounting'
import {paymentRemainingAmount} from '../../utils/paymentEvent'

interface IFormPaymentMethod {
  disableTitle?: boolean
  isPaying?: boolean
  documentId?: string
  paymentId?: string | null
  // โหมด "จ่าย/รับเงินใหม่แทนใบที่ถูกยกเลิกเช็คไป" — id ของ payment ใบเดิมที่กำลังถูกแทนที่
  replacesPaymentId?: string | null
  previousDocument?: any
  currentDocument?: any
  currentDocumentFormItems?: any
  totalAmount: number
  remainingAmount: number
  onFormChange(form: any): void
  onCreatingMethod(status: any): void
}

const FormPaymentMethod: React.FC<IFormPaymentMethod> = ({
  documentId,
  disableTitle,
  isPaying,
  paymentId,
  replacesPaymentId,
  currentDocumentFormItems,
  previousDocument,
  remainingAmount,
  totalAmount,
  currentDocument,
  onCreatingMethod,
  onFormChange,
}) => {
  const { id } = useParams()
  const location = useLocation()
  const {accountCodeOptions, fetchAccountCodes} = useAccounting()
  const isInExpensePage = location.pathname.includes('expense')
  const paymentDialog = useDialog()
  const { useDebouncedEffect } = useCommon()
  const { getBankLabelByCode } = usePayment()
  const [data, setData] = useState([])
  const previousPayment = find(previousDocument?.incomeDocumentPayments, { id: toNumber(paymentId) })
  // paymentId is the parent of a single payment event. Include its channels when
  // a receipt is created so the receipt is not limited to the first bank.
  const previousPaymentGroup = paymentId
    ? (previousDocument?.incomeDocumentPayments || []).filter(
        (payment: any) =>
          Number(payment.id) === toNumber(paymentId) ||
          Number(payment.parentPaymentId || 0) === toNumber(paymentId)
      )
    : []
  // ใบที่ถูกยกเลิกไปแล้วและกำลังจะมีใบใหม่มาแทน — ต้องถูกตัดออกจากฟอร์ม ไม่ใช่แค่ไม่ส่งตอน submit
  // ถ้าปล่อยค้างไว้ ยอดรวมที่จ่ายไปแล้วจะถูกนับซ้ำกับใบใหม่
  const replacedPaymentId = toNumber(replacesPaymentId) || 0
  const replacedPayment = replacedPaymentId
    ? find(currentDocument?.incomeDocumentPayments, { id: replacedPaymentId })
    : undefined
  const [dataDepositDocuments, setDataDepositDocuments] = useState([])
  const [dataCreditDocuments, setDataCreditDocuments] = useState([])
  const [dataDebitDocuments, setDataDebitDocuments] = useState([])
  const [deductPriceInfo, setDeductPriceInfo] = useState({ amount: 0, netAmount: 0, whTaxPrice: 0, type: '' })
  const [options, setOptions] = useState({
    paymentMethods: [...PAYMENT_METHOD_OPTION], debitOptions: [], creditOptions: [],
    depositOptions: []
  })
  const [form, setForm] = useState<any>({
    incomeDocumentPayments: [],
    incomeDocumentPaymentFees: [],
    incomeDocumentPaymentDeductions: [],
    paymentDate: moment().toDate(),
  })

  const formPaymentDefault = {
    paymentMethod: '',
    amount: 0,
    note: '',
    whTaxPrice: 0,
    chequeBank: '',
    chequeDate: '',
    chequeNumber: '',
    chequeBranchNumber: '',
    chequeAccountNo: '',
    // extraWithholdingTaxItems: [],
  }

  let paymentFeePrice = 0
  let paymentPrice = 0
  const currentBillingDocuments = currentDocument?.billingDocuments
  const billingDocTotalAmount = currentBillingDocuments?.reduce((a: any, b: any) => {
    if (b.originalDocument.type === 'credit' && currentBillingDocuments.length !== 1) {
      return a - b.billingAmount
    }

    return a + b.billingAmount
  }, 0)

  const paymentDeductionDepositAmount = form?.incomeDocumentPaymentDeductions?.reduce((a: any, b: any) => {
    if (b.type !== 'deposit') return a

    return a + Number(b.amount || 0)
  }, 0)

  const paymentDeductionCreditAmount = form?.incomeDocumentPaymentDeductions?.reduce((a: any, b: any) => {
    if (b.type !== 'credit') return a

    return a + Number(b.amount || 0)
  }, 0)

  const paymentDeductionDebitAmount = form?.incomeDocumentPaymentDeductions?.reduce((a: any, b: any) => {
    if (b.type !== 'debit') return a

    return a + Number(b.amount || 0)
  }, 0)

  form.incomeDocumentPaymentFees.map((item: any) => {
    const isDeductReceived = Number(item.reason) === -1
    paymentFeePrice += isDeductReceived ? Number(item.amount) * -1 : Number(item.amount)
    paymentPrice += isDeductReceived ? Number(item.amount) : Number(item.amount) * -1
  })

  form.incomeDocumentPayments.map((item: any) => {
    paymentPrice = paymentPrice + Number(item.amount) + Number(item.whTaxPrice)
  })
  const paymentWhTaxPrice = form.incomeDocumentPayments.reduce(
    (total: number, payment: any) => total + Number(payment?.whTaxPrice || 0),
    0
  )

  if (deductPriceInfo.amount > 0) {
    if (deductPriceInfo.type === 'credit') {
      paymentPrice -= deductPriceInfo.amount
    }

    if (deductPriceInfo.type === 'debit') {
      paymentPrice += deductPriceInfo.amount
    }
  }

  if (currentDocument?.type === IncomeDocumentTypes.BILLING && currentBillingDocuments) {
    paymentPrice = billingDocTotalAmount
  }

  const fetchPaymentMethod = async (s: string = '') => {
    try {
      const gateways = await getPaymentGateways()

      // แปลง PaymentGateway เป็นรูปแบบที่ Select component ต้องการ
      const mapped: any = gateways.map((gateway: PaymentGateway) => {
        let label = gateway.name

        // สร้าง label ตามประเภทของ gateway
        if (gateway.gatewayType === 'bank') {
          label = `${gateway.bankName || ''} / No. : ${gateway.accountNo || ''} / Name : ${gateway.accountName || ''}`
        } else if (gateway.gatewayType === 'cash') {
          label = `เงินสด - ${gateway.name}`
        } else if (gateway.gatewayType === 'e_wallet') {
          label = `e-Wallet - ${gateway.name}`
        } else if (gateway.gatewayType === 'advance') {
          label = `สำรองรับ/จ่าย - ${gateway.name}`
        }

        return {
          ...gateway,
          label: label,
          value: gateway.id,
          bank: gateway.bankName,
          accountNo: gateway.accountNo,
          accountName: gateway.accountName,
          gatewayType: gateway.gatewayType
        }
      })

      // รวมกับ PAYMENT_METHOD_OPTION (ที่มี cheque และ create option)
      const option = _.uniqBy([...PAYMENT_METHOD_OPTION, ...mapped], ({ value }) => value)

      setOptions((opt: any) => ({
        ...opt,
        paymentMethods: [...option],
      }))
    } catch (error) {
      console.error('Error fetching payment gateways:', error)
      // ถ้าเกิดข้อผิดพลาด ให้ใช้ PAYMENT_METHOD_OPTION เป็นค่าเริ่มต้น
      setOptions((opt: any) => ({
        ...opt,
        paymentMethods: [...PAYMENT_METHOD_OPTION],
      }))
    }
  }

  useEffect(() => {
    onFormChange({
      incomeDocumentPaymentFees: form.incomeDocumentPaymentFees,
      incomeDocumentPaymentDeductions: form.incomeDocumentPaymentDeductions,
      incomeDocumentPayments: form.incomeDocumentPayments.map((item: any) => {
        const option = find(options.paymentMethods, { value: item.paymentMethod }) as any
        if (!option) return

        return {
          id: id ? item?.id : '',
          date: moment(form?.paymentDate).format('YYYY-MM-DD'),
          gatewayId: option.id === 'cheque' ? '' : option.id,
          bank: option.bank,
          accountNo: option.accountNo,
          accountName: option.accountName,
          amount: item.amount,
          note: item.note,
          whTax: item?.whTax || 0,
          whTaxPrice: item?.whTaxPrice || 0,
          // extraWithholdingTaxItems: item?.extraWithholdingTaxItems || [],
          chequeNumber: item?.chequeNumber || '',
          chequeAccountNumber: item?.chequeAccountNumber || '',
          chequeBranchNumber: item?.chequeBranchNumber || '',
          chequeBank: item?.chequeBank || '',
          chequeDate: item?.chequeDate ? moment(item?.chequeDate).format('YYYY-MM-DD') : '',
        }
      }),
    })
  }, [form])

  useEffect(() => {
    const billingDocuments = currentDocument?.billingDocuments
    const billingPaymentDocuments = currentDocument?.incomeDocumentPayments

    if (!billingDocuments?.length) return

    let billingWhTax = currentDocument.whTaxPrice
    if (billingPaymentDocuments?.length) {
      billingWhTax = billingPaymentDocuments.reduce((sum: any, item: any) => sum + item.whTaxPrice, 0)
    }

    setTimeout(() => {
      setForm({
        ...form,
        incomeDocumentPayments: [
          {
            paymentMethod: options?.paymentMethods[2]?.value,
            amount: (currentDocument.netAmount ?? currentDocument.totalAmount) - billingWhTax,
            note: '',
            whTax: 99,
            whTaxPrice: billingWhTax,
          },
        ],
      })
    }, 500)
  }, [currentDocument, options.paymentMethods])

  // useEffect(() => {
  //   if (!form?.incomeDocumentPaymentDeductions?.type) return
  //
  //   api.request('account/income-document', ({data, meta}) => {
  //     setData(data)
  //   }, {
  //     forDropdown: 1,
  //     types: form?.incomeDocumentPaymentDeductions?.type
  // //     s,
  // //     labCompanyId: _params.labCompanyId,
  // //     types: _params.type !== 'all'
  // //       ? [_params.type]
  // //       : [
  // //         IncomeDocumentTypes.DEBIT,
  // //         IncomeDocumentTypes.CREDIT,
  // //         IncomeDocumentTypes.DEPOSIT,
  // //         IncomeDocumentTypes.INVOICE
  // //       ],
  // //     page
  //   })
  // }, [form?.incomeDocumentPaymentDeductions])

  useEffect(() => {
    fetchPaymentMethod()
    fetchAccountCodes()
  }, [])

  useEffect(() => {
    if (!previousPayment) return

    setForm({
      ...form,
      incomeDocumentPayments: previousPaymentGroup.map((payment: any) => {
        const bank = find(options.paymentMethods, {
          bank: payment.bank,
          accountNo: payment.accountNo,
        }) as any
        return {
          paymentMethod: bank?.value || options?.paymentMethods[2]?.value,
          amount: payment.amount,
          note: payment.note,
          whTax: payment.whTax || 0,
          whTaxPrice: payment.whTaxPrice || 0,
        }
      }),
    })
  }, [previousPayment, options.paymentMethods])

  const getWhTaxPrice = (whTaxPercent?: number) => {
    let documentItemsWhTaxPriceSum = 0
    const whTax = (whTaxPercent || 0) / 100

    currentDocumentFormItems.map((item: any) => {
      if (!isUndefined(whTaxPercent) && whTaxPercent !== 99) {
        if (item?.subTotal) {
          documentItemsWhTaxPriceSum += item.subTotal * whTax
        } else {
          documentItemsWhTaxPriceSum += totalAmount * whTax
        }
      } else {
        documentItemsWhTaxPriceSum += totalAmount * whTax
        // documentItemsWhTaxPriceSum += item.whTaxPrice
      }
    })

    return documentItemsWhTaxPriceSum
  }

  useDebouncedEffect(() => {
    if (options.paymentMethods.length < 2) return
    if (!currentDocumentFormItems?.[0]?.pricePerUnit && currentDocument?.type !== IncomeDocumentTypes.BILLING) return

    const whTaxUniqueArray: any[] = []
    currentDocumentFormItems.map((item: any) => {
      if (!whTaxUniqueArray.includes(item.whTax) && item.whTax !== 0) {
        whTaxUniqueArray.push(item.whTax)
      }
    })

    let sumWhTax = currentDocumentFormItems.reduce((a: any, b: any) => a + Number(b.whTaxPrice), 0)
    const documentItemsWhTaxPriceSum = getWhTaxPrice(whTaxUniqueArray[0] || 0)

    let editableFormPayments = []
    let editableFormPaymentFees = []
    let editableFormPaymentDeduction = []

    if (!isPaying && currentDocument) {
      editableFormPayments = (currentDocument?.incomeDocumentPayments || [])
        .filter((item: any) => !replacedPaymentId || Number(item.id) !== replacedPaymentId)
        .map((item: any) => {
        const currentBankOption = (item?.chequeBank || item?.chequeBranchNumber || item?.chequeNumber)
          ? find(options.paymentMethods, { value: 'cheque' })
          : find(options.paymentMethods, { bank: item.bank, accountNo: item.accountNo }) as any

        return {
          id: item.id,
          paymentMethod: currentBankOption?.value || options?.paymentMethods[2]?.value,
          amount: item.amount,
          note: item.note,
          whTax: item.whTax,
          whTaxPrice: item.whTaxPrice,
          chequeBank: item?.chequeBank || '',
          chequeDate: item?.chequeDate ? moment(item?.chequeDate).toDate() : '',
          chequeAccountNumber: item?.chequeAccountNumber || '',
          chequeBranchNumber: item?.chequeBranchNumber || '',
          chequeNumber: item?.chequeNumber || '',
        }
      })
    }

    if (previousPayment) {
      editableFormPayments = previousPaymentGroup.map((payment: any) => {
        const currentBankOption =
          payment?.chequeBank || payment?.chequeBranchNumber || payment?.chequeNumber
            ? find(options.paymentMethods, {value: 'cheque'})
            : (find(options.paymentMethods, {
                bank: payment.bank,
                accountNo: payment.accountNo,
              }) as any)

        return {
          paymentMethod: currentBankOption?.value || options?.paymentMethods[2]?.value,
          amount: payment.amount,
          note: payment.note,
          whTax: payment.whTax || 0,
          whTaxPrice: payment.whTaxPrice || 0,
          chequeBank: payment?.chequeBank || '',
          chequeDate: payment?.chequeDate ? moment(payment?.chequeDate).toDate() : '',
          chequeAccountNumber: payment?.chequeAccountNumber || '',
          chequeBranchNumber: payment?.chequeBranchNumber || '',
          chequeNumber: payment?.chequeNumber || '',
        }
      })

      if (currentDocument?.incomeDocumentPaymentFees?.length) {
        editableFormPaymentFees = currentDocument?.incomeDocumentPaymentFees.map((f: any) => {
          return {
            reason: Number(f.reason),
            accountCode: Number(f.accountCode),
            amount: f.amount,
            note: f.note,
          }
        })
      }
    }

    // เติมแถวใหม่ให้หนึ่งแถว ดึงยอด/หัก ณ ที่จ่าย/หมายเหตุจากใบเดิมมาให้ แต่ปล่อยวิธีจ่ายกับช่องเช็ค
    // ว่างไว้ เพราะทั้งหมดคือสิ่งที่ผู้ใช้ต้องเลือกใหม่ แถวนี้ไม่มี id จึงเป็น "ใบใหม่" ตอน submit
    if (replacedPayment) {
      editableFormPayments = [
        ...editableFormPayments,
        {
          paymentMethod: '',
          amount: replacedPayment.amount,
          note: replacedPayment.note || '',
          whTax: replacedPayment.whTax || 0,
          whTaxPrice: replacedPayment.whTaxPrice || 0,
          chequeBank: '',
          chequeDate: '',
          chequeAccountNumber: '',
          chequeBranchNumber: '',
          chequeNumber: '',
        },
      ]
    }

    if (currentDocument?.type === 'billing') {
      sumWhTax = currentDocument.billingDocuments.reduce((a: any, b: any) => {
        if (b.originalDocument.type === 'credit' && currentDocument.billingDocuments.length !== 1) {
          return a - b.whTaxPrice
        }

        return a + b.whTaxPrice
      }, 0)
    }

    const activeStoredPayments = (currentDocument?.incomeDocumentPayments || []).filter(
      (payment: any) => !payment?.cancelledAt && !payment?.cancelled_at
    )
    const totalAmountReceived = activeStoredPayments.reduce(
      (total: number, payment: any) => total + Number(payment?.amount || 0),
      0
    )
    const totalWhTaxReceived = activeStoredPayments.reduce(
      (total: number, payment: any) => total + Number(payment?.whTaxPrice || 0),
      0
    )

    let paymentAmount = parseFloat((totalAmount - sumWhTax).toFixed(2))
    let paymentWhTax = parseFloat(sumWhTax.toFixed(2))

    if (activeStoredPayments.length > 0) {
      paymentAmount = currentDocument.netAmount - totalAmountReceived
      paymentWhTax = currentDocument.whTaxPrice - totalWhTaxReceived
    }

    const documentBillingHistories = currentDocument?.billingHistories
    const relateBillingHistories = find(documentBillingHistories, { originalDocumentId: currentDocument?.id })
    const totalBillingNoteReceived = relateBillingHistories?.billingAmount || 0

    if (totalBillingNoteReceived > 0) {
      if (paymentAmount + paymentWhTax === totalAmount) {
        paymentAmount = totalBillingNoteReceived
        paymentWhTax = 0
      }
    }

    const groupedByWhTax = Object.values(
      currentDocumentFormItems.reduce((acc: Record<number, any[]>, item: any) => {
        const key = item.whTax

        if (key === 0 || key === 99) return acc
        if (!acc[key]) {
          acc[key] = []
        }

        acc[key].push(item)
        return acc
      }, {})
    )

    setForm({
      ...form,
      incomeDocumentPaymentFees: editableFormPaymentFees,
      incomeDocumentPayments: editableFormPayments.length ? editableFormPayments : [
        {
          paymentMethod: options?.paymentMethods[2]?.value,
          amount: paymentAmount,
          // extraWithholdingTaxItems: groupedByWhTax.map((itemGroup: any, index: number) => {
          //   return {
          //     amount: paymentAmount,
          //     whTax: itemGroup[0].whTax,
          //     whTaxPrice: Math.round(
          //       itemGroup.reduce((a: number, b: any) => a + Number(b.whTaxPrice), 0) * 100
          //     ) / 100
          //   }
          // }),
          note: '',
          whTax: whTaxUniqueArray.length
            ? whTaxUniqueArray.length > 1
              ? 99
              : whTaxUniqueArray[0]
            : 0,
          whTaxPrice: paymentWhTax,
        },
      ],
    })
  }, [previousPayment, currentDocument, currentDocumentFormItems, totalAmount, options.paymentMethods], 1000)

  const documentBillingHistories = currentDocument?.billingHistories
  const relateBillingHistories = find(documentBillingHistories, { originalDocumentId: currentDocument?.id })
  const totalBillingNoteReceived = relateBillingHistories?.billingAmount || 0

  let awaitReceivedPaymentAmount =
    paymentRemainingAmount(totalAmount, form.incomeDocumentPayments, form.incomeDocumentPaymentFees) +
    Number((-paymentDeductionCreditAmount + paymentDeductionDebitAmount).toFixed(2))
  awaitReceivedPaymentAmount -= paymentDeductionDepositAmount
  awaitReceivedPaymentAmount -= totalBillingNoteReceived

  return (
    <div>
      {!disableTitle && <h2 className={'mb-3 h3'}>รับชำระเงิน</h2>}
      <Row>
        <Col xs={12}>
          <Form.Group className='mb-5' controlId='paymentDate'>
            <Form.Label>วันที่รับชำระ</Form.Label>
            <DatePicker
              disabled={previousPayment}
              onChange={(date: Date, e: any) => {
                setForm({ ...form, paymentDate: date })
              }}
              name='paymentDate'
              selected={form.paymentDate || null}
              dateFormat='dd/MM/yyyy'
              timeCaption='time'
              showMonthDropdown
              showYearDropdown
              dropdownMode='select'
            />
          </Form.Group>
        </Col>
      </Row>
      {form.incomeDocumentPayments.map((item: any, index: number) => {
        const currentFormPayment = form.incomeDocumentPayments[index]

        const _setFormPayment = (newValue: any) => {
          const newPayment = form.incomeDocumentPayments.map(
            (payment: any, paymentIndex: number) => {
              return paymentIndex !== index
                ? payment
                : {
                  ...form.incomeDocumentPayments[index],
                  ...newValue,
                }
            }
          )

          setForm({
            ...form,
            incomeDocumentPayments: newPayment,
          })
        }

        const CustomOption = (props: any) => {
          const { data, innerRef, innerProps } = props

          if (data.value === 'create') {
            return (
              <>
                <div
                  ref={innerRef}
                  {...innerProps}
                  onClick={() => {
                    paymentDialog.handleModalOpen()
                    onCreatingMethod(true)
                  }}
                  className={'btn btn-info btn-block w-100 px-2 cursor-pointer rounded-0 text-left'}
                >
                  {data.label}
                </div>
              </>
            )
          }

          return <components.Option {...props} />
        }

        return (
          <Row key={`payment-item-${index}`} className={'gx-2'}>
            <Col xs={6} md={4}>
              <Form.Group className='mb-5'>
                <Form.Label>รับชำระโดย</Form.Label>
                <Select
                  isDisabled={previousPayment}
                  classNamePrefix='react-select'
                  options={options.paymentMethods}
                  name={`paymentMethod_${index}`}
                  components={{ Option: CustomOption }}
                  onChange={(opt) => {
                    if (opt.value === 'create') return
                    let _form = {
                      paymentMethod: opt.value,
                    } as any

                    if (opt.value !== 'cheque') {
                      _form = {
                        ..._form,
                        chequeBank: '',
                        chequeAccountNumber: '',
                        chequeBranchNumber: '',
                        chequeNumber: '',
                        chequeDate: '',
                      }
                    }

                    _setFormPayment(_form)
                  }}
                  value={reactSelectValue(options.paymentMethods, currentFormPayment.paymentMethod)}
                />
              </Form.Group>
            </Col>
            <Col xs={6} md={4}>
              <Form.Group className='mb-5' controlId={'paymentAmount'}>
                <Form.Label>จำนวนเงินที่ชำระ</Form.Label>
                <Form.Control
                  inputMode={'numeric'}
                  disabled={previousPayment}
                  name={`paymentAmount_${index}`}
                  value={currentFormPayment.amount}
                  className={'text-primary fw-bold'}
                  // onFocus={() => {
                  //   if (index !== 0 || includes([0, 99], currentFormPayment.whTax)) return
                  //
                  //   _setFormPayment({
                  //     amount: totalAmount,
                  //     whTax: 0,
                  //     whTaxPrice: 0,
                  //   })
                  // }}
                  onChange={(e) => {
                    _setFormPayment({
                      amount: e.target.value,
                    })
                  }}
                />
              </Form.Group>
            </Col>
            <Col xs={6} md={4}>
              <Form.Group className='mb-5' controlId={'paymentNote'}>
                <Form.Label>หมายเหตุ</Form.Label>
                <Form.Control
                  disabled={previousPayment}
                  name={`paymentNote_${index}`}
                  value={currentFormPayment.note}
                  onChange={(e) => {
                    _setFormPayment({
                      note: e.target.value,
                    })
                  }}
                />
              </Form.Group>
            </Col>
            {currentFormPayment.paymentMethod === 'cheque' && (
              <Col xs={12} className={'mb-3'}>
                <div
                  className={'p-3'}
                  style={{ borderRadius: '.5rem', background: 'rgba(46,57,139,.1)' }}
                >
                  <Row className={'g-2'}>
                    <Col xs={12}>
                      <strong className={'text-danger'}>
                        {'*** ถ้ารับชำระด้วยเช็ค ให้กรอกข้อมูลส่วนนี้ให้ครบถ้วน'}
                      </strong>
                    </Col>
                    <Col xs={6} md={4}>
                      <Form.Group controlId={'chequeNumber'}>
                        <Form.Label>เลขที่เช็ค</Form.Label>
                        <Form.Control
                          disabled={previousPayment}
                          name={`chequeNumber_${index}`}
                          value={currentFormPayment.chequeNumber}
                          onChange={(e) => {
                            _setFormPayment({
                              chequeNumber: e.target.value,
                            })
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={6} md={4}>
                      <Form.Group controlId={'chequeBranchNumber'}>
                        <Form.Label>เลขที่สาขา</Form.Label>
                        <Form.Control
                          disabled={previousPayment}
                          name={`chequeBranchNumber_${index}`}
                          value={currentFormPayment.chequeBranchNumber}
                          onChange={(e) => {
                            _setFormPayment({
                              chequeBranchNumber: e.target.value,
                            })
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={6} md={4}>
                      <Form.Group controlId={'chequeAccountNumber'}>
                        <Form.Label>เลขที่บัญชีในเช็ค</Form.Label>
                        <Form.Control
                          disabled={previousPayment}
                          name={`chequeAccountNumber_${index}`}
                          value={currentFormPayment.chequeAccountNumber}
                          onChange={(e) => {
                            _setFormPayment({
                              chequeAccountNumber: e.target.value,
                            })
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={6} md={4}>
                      <Form.Group controlId={'chequeBank'}>
                        <Form.Label>ธนาคารที่ระบุไว้</Form.Label>
                        <Select
                          classNamePrefix='react-select'
                          options={BANK_LIST_ONLY_OPTIONS}
                          name={`chequeBank_${index}`}
                          onChange={(opt) => {
                            _setFormPayment({
                              chequeBank: opt.value,
                            })
                          }}
                          value={reactSelectValue(
                            BANK_LIST_ONLY_OPTIONS,
                            currentFormPayment.chequeBank
                          )}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={6} md={4}>
                      <Form.Group className='mb-5' controlId='chequeDate'>
                        <Form.Label>วันที่ในเช็ค</Form.Label>
                        <DatePicker
                          disabled={previousPayment}
                          onChange={(date: Date, e: any) => {
                            _setFormPayment({
                              chequeDate: date,
                            })
                          }}
                          name={`chequeDate_${index}`}
                          selected={currentFormPayment.chequeDate || null}
                          dateFormat='dd/MM/yyyy'
                          timeCaption='time'
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode='select'
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </Col>
            )}
            {index === 0 && (
              <>
                <Col xs={6} md={4}>
                  <Form.Group className='mb-5' controlId={`whTax_${index}`}>
                    <Form.Label>ถูกหัก ณ ที่จ่าย</Form.Label>
                    <Select
                      classNamePrefix='react-select'
                      className={'text-primary fw-bold'}
                      options={TAX_OPTIONS}
                      name={`whTax_${index}`}
                      value={reactSelectValue(TAX_OPTIONS, item.whTax)}
                      onChange={({ value }) => {
                        const whTaxPrice = getWhTaxPrice(value)

                        _setFormPayment({
                          amount: totalAmount - whTaxPrice,
                          whTax: value,
                          whTaxPrice: whTaxPrice,
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col xs={6} md={4}>
                  <Form.Group className='mb-5' controlId={'whTaxPrice'}>
                    <Form.Label>มูลค่าถูกหัก ณ ที่จ่าย</Form.Label>
                    <Form.Control
                      inputMode={'numeric'}
                      disabled={previousPayment}
                      name={`whTaxPrice_${index}`}
                      value={currentFormPayment.whTaxPrice}
                      className={'text-primary fw-bold'}
                      onChange={(e) => {
                        _setFormPayment({
                          // amount: totalAmount - value,
                          whTax: 99,
                          whTaxPrice: e.target.value,
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
              </>
            )}
            <Col xs={12}>
              {!previousPayment && (
                <div className={'text-right'}>
                  <div className={'ms-auto'} style={{ width: 'fit-content' }}>
                    <Form.Group className='mb-5'>
                      <Button
                        variant={'danger'}
                        size={'sm'}
                        className={'px-4 py-0'}
                        onClick={() => {
                          setForm({
                            ...form,
                            incomeDocumentPayments: [
                              ...form.incomeDocumentPayments.slice(0, index),
                              ...form.incomeDocumentPayments.slice(index + 1),
                            ],
                          })
                        }}
                      >
                        {'ลบ'}
                      </Button>
                    </Form.Group>
                  </div>
                </div>
              )}
            </Col>
          </Row>
        )
      })}
      <div>
        <Button
          variant='link'
          className={'p-0'}
          onClick={() => {
            setForm((prev: any) => ({
              ...prev,
              incomeDocumentPayments: [...prev.incomeDocumentPayments, formPaymentDefault],
            }))
          }}
        >
          <i className='fa fa-plus fs-9 text-primary' />
          {'เพิ่มช่องทางการรับชำระเงิน'}
        </Button>
      </div>
      <hr />
      <div>
        <strong className={'fs-5'}>ค่าธรรมเนียม หรือรายการปรับปรุง</strong>
        {form?.incomeDocumentPaymentFees?.map((item: any, index: any) => {
          const _setFromIncomeDocumentFee = (newValue: object) => {
            const newProductItems = form.incomeDocumentPaymentFees.map(
              (product: any, productIndex: number) => {
                return productIndex !== index
                  ? product
                  : {
                    ...product,
                    ...newValue,
                  }
              }
            )

            const whTaxUniqueArray: any[] = []
            currentDocumentFormItems.map((item: any) => {
              if (!whTaxUniqueArray.includes(item.whTax) && item.whTax !== 0) {
                whTaxUniqueArray.push(item.whTax)
              }
            })

            const documentWhTaxPriceSum = getWhTaxPrice(whTaxUniqueArray[0] || 0)
            const totalPaymentWhTax = form.incomeDocumentPayments.reduce((a: any, b: any) => a + b.whTaxPrice, 0)
            const totalDeductions = form.incomeDocumentPaymentDeductions.reduce((a: any, b: any) => {
              const currentDeductDoc = find(dataCreditDocuments, { id: b.incomeDocumentId }) as any
              return a + Number(currentDeductDoc?.netAmount || 0)
            }, 0)
            const totalFees = newProductItems.reduce((a: any, b: any) => a + (b.reason === 1 ? Number(b.amount) : Number(b.amount) * -1), 0)
            const updatePayments = form.incomeDocumentPayments.map(
              (payment: any, paymentIndex: number) => {
                return paymentIndex !== 0
                  ? payment
                  : {
                    ...payment,
                    amount: totalAmount - totalPaymentWhTax + totalFees - totalDeductions,
                  }
              }
            )

            setForm({
              ...form,
              incomeDocumentPayments: updatePayments,
              incomeDocumentPaymentFees: newProductItems,
            })
          }

          return (
            <div key={`incomeDocumentFee-${index}`} className={'mb-3'}>
              <Row className={'gx-2'}>
                <Col>
                  <Form.Group className='mb-2' controlId={'reason'}>
                    <Form.Label>{'ปรับปรุง'}</Form.Label>
                    <Select
                      classNamePrefix='react-select'
                      className={'text-primary fw-bold'}
                      options={PAYMENT_ADJUSTMENT_OPTIONS}
                      name='reason'
                      onChange={(opt, action) => {
                        _setFromIncomeDocumentFee({
                          reason: opt.value,
                        })
                      }}
                      value={reactSelectValue(PAYMENT_ADJUSTMENT_OPTIONS, item.reason)}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className='mb-2' controlId={'accountCode'}>
                    <Form.Label>{'ปรับปรุงด้วยบัญชี'}</Form.Label>
                    <Select
                      classNamePrefix='react-select'
                      className={'text-primary fw-bold'}
                      options={[
                        ...PAYMENT_ADJUSTMENT_ACCOUNT_OPTIONS,
                        ...accountCodeOptions,
                      ]}
                      name='accountCode'
                      onChange={(opt, action) => {
                        _setFromIncomeDocumentFee({
                          accountCode: opt.value,
                        })
                      }}
                      value={reactSelectValue([
                        ...PAYMENT_ADJUSTMENT_ACCOUNT_OPTIONS,
                        ...accountCodeOptions,
                      ], item.accountCode)}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className='mb-2' controlId={'amount'}>
                    <Form.Label>จำนวนเงินที่ปรับปรุง</Form.Label>
                    <Form.Control
                      name={'amount'}
                      value={item?.amount}
                      className={'text-primary fw-bold'}
                      onChange={(e) => {
                        _setFromIncomeDocumentFee({
                          amount: e.target.value,
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className='mb-2' controlId={'note'}>
                    <Form.Label>หมายเหตุ</Form.Label>
                    <Form.Control
                      name={'note'}
                      value={item?.note}
                      onChange={(e) => {
                        _setFromIncomeDocumentFee({
                          note: e.target.value,
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <div className={'text-end'}>
                <Button
                  variant={'danger'}
                  size={'sm'}
                  className={'px-4 py-0'}
                  onClick={() => {
                    setForm((prev: any) => ({
                      ...prev,
                      incomeDocumentPaymentFees: prev.incomeDocumentPaymentFees.filter(
                        (_: any, i: any) => i !== index
                      ),
                    }))
                  }}
                >
                  {'ลบ'}
                </Button>
              </div>
            </div>
          )
        })}
        <div>
          <Button
            variant='link'
            className={'p-0'}
            onClick={() => {
              setForm((prev: any) => ({
                ...prev,
                incomeDocumentPaymentFees: [
                  ...prev.incomeDocumentPaymentFees,
                  {
                    reason: PAYMENT_ADJUSTMENT_OPTIONS[0].value,
                    accountCode:
                      find(PAYMENT_ADJUSTMENT_ACCOUNT_OPTIONS, { value: 999999 })?.value ||
                      PAYMENT_ADJUSTMENT_ACCOUNT_OPTIONS[0].value,
                    amount: 0,
                    note: '',
                  },
                ],
              }))
            }}
          >
            <i className='fa fa-plus fs-9 text-primary' />
            {'เพิ่มค่าธรรมเนียม หรือรายการปรับปรุง'}
          </Button>
        </div>
      </div>
      <hr />
      <div>
        <strong className={'fs-5'}>ตัดชำระกับเอกสาร</strong>
        {form?.incomeDocumentPaymentDeductions?.map((item: any, index: any) => {
          // const currentDebitItem = find(dataDebitDocuments, {code: item.incomeDocumentId})
          // const currentCreditItem = find(dataCreditDocuments, {code: item.incomeDocumentId})

          const getDocumentTypeOption = (type: IncomeDocumentTypes) => {
            api.request(
              'account/income-document',
              ({ data, meta }) => {
                if (!data.length) return
                setOptions({
                  ...options,
                  [`${type}Options`]: data.map((item: any) => ({ label: item.code, value: item.id })),
                })

                switch (type) {
                  case IncomeDocumentTypes.DEPOSIT:
                    setDataDepositDocuments(data)
                    break
                  case IncomeDocumentTypes.DEBIT:
                    setDataDebitDocuments(data)
                    break
                  case IncomeDocumentTypes.CREDIT:
                    setDataCreditDocuments(data)
                    break
                }
              },
              {
                page: 1,
                limit: 100,
                type: type,
                // state: IncomeDocumentStateTypes.AWAIT_DEDUCT,
                labCompanyId: currentDocument?.labCompanyId,
              }
            )
          }

          const _setFromIncomeDocumentDeduct = (newValue: any) => {
            const newProductItems = form.incomeDocumentPaymentDeductions.map((product: any, productIndex: number) =>
              productIndex === index ? { ...product, ...newValue } : product
            );

            const whTaxUniqueArray: any[] = []
            currentDocumentFormItems.map((item: any) => {
              if (!whTaxUniqueArray.includes(item.whTax) && item.whTax !== 0) {
                whTaxUniqueArray.push(item.whTax)
              }
            })

            const _deductAmountInfo = newProductItems.reduce((acc: any, item: any) => {
              const dataList = item.type === IncomeDocumentTypes.CREDIT
                ? dataCreditDocuments
                : item.type === IncomeDocumentTypes.DEPOSIT
                  ? dataDepositDocuments
                  : dataDebitDocuments;
              const currentDoc = find(dataList, { id: item.incomeDocumentId }) as any;

              return {
                amount: acc.amount + Number(currentDoc?.totalAmount || 0),
                netAmount: acc.netAmount + Number(currentDoc?.netAmount || 0),
                whTaxPrice: acc.whTaxPrice + Number(currentDoc?.whTaxPrice || 0),
                type: acc.type
              };
            }, { amount: 0, netAmount: 0, whTaxPrice: 0, type: '' });

            setDeductPriceInfo(_deductAmountInfo)
            const documentWhTaxPriceSum = getWhTaxPrice(whTaxUniqueArray[0] || 0)
            const totalFees = form.incomeDocumentPaymentFees.reduce((a: any, b: any) => a + (b.reason === 1 ? Number(b.amount) : Number(b.amount) * -1), 0)
            const updatePayments = form.incomeDocumentPayments.map(
              (payment: any, paymentIndex: number) => {
                if (paymentIndex !== 0 || _deductAmountInfo.amount === 0) return payment

                return {
                  ...payment,
                  amount: Number((totalAmount - payment.whTaxPrice - _deductAmountInfo.netAmount + totalFees).toFixed(2)),
                  whTaxPrice: payment.whTaxPrice - _deductAmountInfo.whTaxPrice
                }
              }
            )

            setForm({
              ...form,
              incomeDocumentPayments: updatePayments,
              incomeDocumentPaymentDeductions: newProductItems,
            })
          }

          return (
            <div key={`incomeDocumentDeduct-${index}`} className={'mb-3'}>
              <Row className={'gx-2'}>
                <Col>
                  <Form.Group className='mb-2' controlId={`type_${index}`}>
                    <Form.Label>{'ประเภทเอกสาร'}</Form.Label>
                    <Select
                      classNamePrefix='react-select'
                      className={'text-primary fw-bold'}
                      options={isInExpensePage ? DEDUCT_DOCUMENT_TYPE_OPTIONS : DEDUCT_DOCUMENT_INCOME_TYPE_OPTIONS}
                      name={`type_${index}`}
                      onChange={async (opt, action) => {
                        getDocumentTypeOption(opt.value)
                        _setFromIncomeDocumentDeduct({
                          type: opt.value,
                          amount: 0,
                          incomeDocumentId: '',
                        })
                      }}
                      value={reactSelectValue(isInExpensePage ? DEDUCT_DOCUMENT_TYPE_OPTIONS : DEDUCT_DOCUMENT_INCOME_TYPE_OPTIONS, item.type)}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className='mb-2' controlId={`incomeDocumentId_${index}`}>
                    <Form.Label>{'เลขที่เอกสาร'}</Form.Label>
                    <Select
                      isDisabled={!item?.type}
                      classNamePrefix='react-select'
                      className={'text-primary fw-bold'}
                      options={
                        item.type === IncomeDocumentTypes.CREDIT
                          ? options.creditOptions
                          : item.type === IncomeDocumentTypes.DEPOSIT
                            ? options.depositOptions
                            : options.debitOptions
                      }
                      name={`incomeDocumentId_${index}`}
                      onChange={(opt, action) => {
                        const value = opt.value
                        const dataList = item.type === IncomeDocumentTypes.CREDIT
                          ? dataCreditDocuments
                          : (item.type === IncomeDocumentTypes.DEPOSIT
                            ? dataDepositDocuments
                            : dataDebitDocuments)
                        const currentData = find(dataList, { id: value }) as any
                        _setFromIncomeDocumentDeduct({
                          incomeDocumentId: value,
                          amount: Number(currentData?.totalAmount || 0)
                        })
                      }}
                      value={reactSelectValue(
                        item.type === IncomeDocumentTypes.CREDIT
                          ? options.creditOptions
                          : item.type === IncomeDocumentTypes.DEPOSIT
                            ? options.depositOptions
                            : options.debitOptions,
                        item.incomeDocumentId
                      )}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className='mb-2' controlId={`amount_${index}`}>
                    <Form.Label>จำนวนเงินที่รับชำระ</Form.Label>
                    <Form.Control
                      disabled={!item?.type || !item?.incomeDocumentId}
                      name={`amount_${index}`}
                      value={item?.amount}
                      className={'text-primary fw-bold'}
                      onChange={(e) => {
                        _setFromIncomeDocumentDeduct({
                          amount: e.target.value,
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className='mb-2' controlId={`note_${index}`}>
                    <Form.Label>หมายเหตุ</Form.Label>
                    <Form.Control
                      disabled={!item?.type || !item?.incomeDocumentId}
                      name={`note_${index}`}
                      value={item?.note}
                      onChange={(e) => {
                        _setFromIncomeDocumentDeduct({
                          note: e.target.value,
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <div className={'text-end'}>
                <Button
                  variant={'danger'}
                  size={'sm'}
                  className={'px-4 py-0'}
                  onClick={() => {
                    setForm((prev: any) => ({
                      ...prev,
                      incomeDocumentPaymentDeductions: prev.incomeDocumentPaymentDeductions.filter(
                        (_: any, i: any) => i !== index
                      ),
                    }))
                  }}
                >
                  {'ลบ'}
                </Button>
              </div>
            </div>
          )
        })}
        <div>
          <Button
            variant='link'
            className={'p-0'}
            onClick={() => {
              setForm((prev: any) => ({
                ...prev,
                incomeDocumentPaymentDeductions: [
                  ...prev.incomeDocumentPaymentDeductions,
                  {
                    type: '',
                    incomeDocumentId: '',
                    amount: 0,
                    note: '',
                  },
                ],
              }))
            }}
          >
            <i className='fa fa-plus fs-9 text-primary' />
            {'ตัดชำระกับเอกสาร'}
          </Button>
        </div>
      </div>
      {/*{!previousPayment && (*/}
      {/*  <Row>*/}
      {/*    <Col>*/}
      {/*      <Button*/}
      {/*        size={'sm'}*/}
      {/*        variant={'primary'}*/}
      {/*        onClick={() => {*/}
      {/*          setForm({*/}
      {/*            ...form,*/}
      {/*            incomeDocumentPayments: [...form.incomeDocumentPayments, formPaymentDefault],*/}
      {/*          })*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        {'+ เพิ่มช่องทางการชำระเงิน'}*/}
      {/*      </Button>*/}
      {/*    </Col>*/}
      {/*  </Row>*/}
      {/*)}*/}
      <div className={'d-flex flex-column align-items-end text-end'}>
        <div className={'d-flex align-items-end bg-success py-3 px-5 rounded text-black'}>
          <span>รับชำระรวมทั้งสิ้น</span>
          <span className={'h1 mb-0 ps-5 pe-3 text-black'} style={{ minWidth: 150 }}>
            {numberFormat(paymentPrice)}
          </span>
          <span>บาท</span>
        </div>
        {deductPriceInfo.amount > 0 && (
          <div className={'d-flex justify-content-end mt-1'}>
            <span>ตัดชำระ</span>
            <span className={'h4 ps-5 pe-3 mb-0'} style={{ minWidth: 150 }}>
              {numberFormat(deductPriceInfo.amount)}
            </span>
            <span>บาท</span>
          </div>
        )}
        <div className={'d-flex justify-content-end mt-1'}>
          <span>ต้องชำระเงินอีก</span>
          <span className={'h4 ps-5 pe-3 mb-0'} style={{ minWidth: 150 }}>
            {numberFormat(paymentId
              ? 0
              : awaitReceivedPaymentAmount
            )}
            {/*{numberFormat(previousPayment ? 0 : remainingAmount)}*/}
          </span>
          <span>บาท</span>
        </div>
        {form.incomeDocumentPaymentFees.length !== 0 && (
          <div className={'d-flex justify-content-end mt-1'}>
            <span>ปรับปรุงรวม</span>
            <span className={'h4 ps-5 pe-3 mb-0'} style={{ minWidth: 150 }}>
              {Math.sign(paymentFeePrice) === -1
                ? `(${numberFormat(paymentFeePrice * -1)})`
                : numberFormat(paymentFeePrice)}
            </span>
            <span>บาท</span>
          </div>
        )}
        <div className={'d-flex justify-content-end mt-1'}>
          <span>รับชำระด้วยเงินรวม</span>
          <span className={'h4 ps-5 pe-3 mb-0'} style={{ minWidth: 150 }}>
            {numberFormat(paymentPrice + paymentFeePrice - paymentWhTaxPrice)}
          </span>
          <span>บาท</span>
        </div>
        {paymentWhTaxPrice !== 0 && (
          <div className={'d-flex justify-content-end mt-1'}>
            <span>ถูกหัก ณ ที่จ่าย</span>
            <strong className={'h4 ps-5 pe-3 mb-0'} style={{ minWidth: 150 }}>
              {numberFormat(paymentWhTaxPrice)}
            </strong>
            <span>บาท</span>
          </div>
        )}
      </div>
      <ModalPaymentMethodForm
        show={paymentDialog.show}
        onClose={() => {
          paymentDialog.handleModalClose()
          onCreatingMethod(false)
        }}
        onSubmitSuccess={() => {
          fetchPaymentMethod()
          paymentDialog.handleModalClose()
          onCreatingMethod(false)
        }}
      />
    </div>
  )
}

export default FormPaymentMethod
